import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-operation-reason',
  templateUrl: './operation-reason.component.html',
  styleUrls: ['./operation-reason.component.scss']
})
export class OperationReasonComponent implements OnInit {
  @Input('operationReasonFormControl') operationReasonFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Output() onOperationReasonSelected: EventEmitter<string> = new EventEmitter<string>();
  public reasons = [
    {
      name: 'Professional',
      description: 'For professional reason'
    },
    {
      name: 'Family',
      description: 'For family reason'
    },
    {
      name: 'Disease',
      description: 'For disease reason'
    },
    {
      name: 'Wedding',
      description: 'For wedding reason'
    },
    {
      name: 'Commercial',
      description: 'For commercial reason'
    },
    {
      name: 'Other',
      description: 'Other reason'
    }
  ];
  constructor() { }

  ngOnInit() {
  }
  onReasonSelection(e) {
    if (e.value) {
      this.onOperationReasonSelected.emit(this.operationReasonFormControl.value);
    }
  }
  onOtherReasonBlur(e) {
    if (e.target.value) {
      this.reasons.push({name: e.target.value, description: e.target.value});
      this.onOperationReasonSelected.emit(e.target.value);
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/operation-reason/operation-reason.component.ts